import React, { useState } from 'react';
import { Alert, styled } from '@nextiva/next-ui-components';
import { SaveUserChangesModal } from './SaveUserChangesModal';

const StyledBannerContainer = styled('div')`
  margin-bottom: 20px;
`;
const StyledLink = styled('a')`
  text-decoration: underline;
  color: ${({ theme }) => theme.palette.primary.main} !important;
  cursor: pointer;
`;

const LICENSES_LINK = 'apps/platform-admin/#/licensing/licenses';

interface IPurchaseAdditionalLicensesBanner {
  unsavedUserChanges: boolean;
  saveChanges: (unsavedChangesFlow: boolean) => void;
}

export const PurchaseAdditionalLicensesBanner = ({
  unsavedUserChanges,
  saveChanges,
}: IPurchaseAdditionalLicensesBanner) => {
  const [saveChangesModalOpen, setSaveChangesModalOpen] = useState<boolean>(
    false,
  );

  const onPurchaseLicenseLinkClick = (): void => {
    if (unsavedUserChanges) {
      setSaveChangesModalOpen(true);
    } else {
      Object.defineProperty(window, 'location', {
        value: `${window.location.origin}/${LICENSES_LINK}`,
      });
    }
  };

  const onSaveButtonClick = (): void => {
    setSaveChangesModalOpen(false);
    saveChanges(true);
  };

  const onCancelButtonClick = (): void => {
    setSaveChangesModalOpen(false);
  };

  return (
    <>
      {saveChangesModalOpen && (
        <SaveUserChangesModal
          onSaveButtonClick={onSaveButtonClick}
          onCancelButtonClick={onCancelButtonClick}
        />
      )}
      <StyledBannerContainer>
        <Alert
          severity="info"
          data-testid="PlatformAdminUI-ManageUserDrawer-PurchaseLicenseBanner"
        >
          <p>
            Now assign your user a license. If you’ve used all your available
            licenses,{' '}
            <StyledLink
              onClick={onPurchaseLicenseLinkClick}
              data-testid="PlatformAdminUI-ManageUserDrawer-PurchaseLicenseLink"
              role="link"
            >
              purchase additional licenses
            </StyledLink>{' '}
            to add this user.
          </p>
        </Alert>
      </StyledBannerContainer>
    </>
  );
};
